import * as React from "react";
const SvgUnreadDot = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 5 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 2.5, cy: 4.5, r: 2.5, fill: "#EC4E4E" }));
export default SvgUnreadDot;
